import React from 'react';
import { Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import './BrandsSidebar.scss';
import { useTranslation } from 'react-i18next';

function BrandsSidebar({ brands, selectedBrand, selectedModel, onSelectBrand, onSelectModel }) {
  const { t } = useTranslation();

  // Ordina i brands alfabeticamente
  const sortedBrands = [...brands].sort((a, b) => a.name.localeCompare(b.name));

  const handleBrandClick = (brandName) => {
    if (selectedBrand === brandName) {
      onSelectBrand(null);
      onSelectModel(null);
    } else {
      onSelectBrand(brandName);
      onSelectModel(null);
    }
  };

  return (
    <div className="brands-sidebar p-4">
      <h2 className="h4 mb-4">{t('inventory.title')}</h2>
      <Nav className="flex-column">
        {sortedBrands.map(brand => (
          <div key={brand.name} className="brand-item">
            <Nav.Link 
              className={`d-flex align-items-center justify-content-between py-2 brand-link ${selectedBrand === brand.name ? 'active' : ''}`}
              onClick={() => handleBrandClick(brand.name)}
            >
              <span>{brand.name}</span>
              <FontAwesomeIcon 
                icon={selectedBrand === brand.name ? faChevronDown : faChevronRight} 
                className={`chevron-icon ${selectedBrand === brand.name ? 'rotated' : ''}`}
              />
            </Nav.Link>
            
            <div className={`models-container ${selectedBrand === brand.name ? 'expanded' : ''}`}>
              <Nav className="flex-column ms-4">
                {/* Ordina i modelli alfabeticamente */}
                {[...brand.models].sort((a, b) => a.localeCompare(b)).map(model => (
                  <Nav.Link
                    key={model}
                    className={`py-2 model-link ${selectedModel === model ? 'active' : ''}`}
                    onClick={() => onSelectModel(model)}
                  >
                    {model}
                  </Nav.Link>
                ))}
              </Nav>
            </div>
          </div>
        ))}
      </Nav>
    </div>
  );
}

export default BrandsSidebar; 